import { render, staticRenderFns } from "./SearchFacets.vue?vue&type=template&id=b034f95a"
import script from "./SearchFacets.vue?vue&type=script&lang=ts"
export * from "./SearchFacets.vue?vue&type=script&lang=ts"
import style0 from "./SearchFacets.vue?vue&type=style&index=0&id=b034f95a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports